import { type QueryKey } from 'react-query';

export const getCostCentersQueryKey = (
  companyId: string,
  params?: { withDeleted?: boolean; includeUsers?: boolean },
): QueryKey => {
  return ['costCenters', companyId, params].filter(Boolean);
};
